import { useEffect, useState } from "react";
import { HttpMainApi } from "../../../interface/main-api";
import type { HourlyWeatherItem, WeatherQueryResult } from "../weatherTypes";

const WEATHER_COORDS = { lat: 37.76, lon: 126.78 };
const mainApi = new HttpMainApi();

export const useHourlyWeatherInfo = (): WeatherQueryResult<HourlyWeatherItem[]> => {
  const [data, setData] = useState<HourlyWeatherItem[]>();
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    let mounted = true;

    const loadHourlyWeatherInfo = async () => {
      setIsSuccess(false);
      const response = await mainApi.get_hourly_weather_info({ params: WEATHER_COORDS });
      if (!mounted) return;

      const responseBody = response?.response ?? response;
      setData(responseBody?.hourlyWeatherInfo ?? responseBody ?? []);
      setIsSuccess(true);
    };

    loadHourlyWeatherInfo();

    return () => {
      mounted = false;
    };
  }, []);

  return { data, isSuccess };
};
